import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseCatalogueSearchComponent } from './course-catalogue-search/course-catalogue-search.component';
import { SharedModule } from '../shared/shared.module';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { PanelHubComponent } from '../shared-components/panel-hub/panel-hub.component';

@NgModule({
  declarations: [
    CourseCatalogueSearchComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BptSearchModule,
    TooltipModule,
    FormsModule,
    EmptyResultsComponent,
    SpinnerComponent,
    PanelHubComponent
  ],
  exports: [
    CourseCatalogueSearchComponent]
})
export class CourseCatalogueModule { }
